export default "__VITE_ASSET__bTJIPik7__"